import { Typography } from '@_shared/ui/Typography';

import * as S from './TitleHeader.style';

interface TitleHeaderProps {
	children: React.ReactNode;
}

export function TitleHeader({ children }: TitleHeaderProps) {
	return (
		<S.Container>
			<Typography type="title-large" color="font-primary">
				{children}
			</Typography>
		</S.Container>
	);
}
